module.exports = __webpack_public_path__ + "static/media/image_add_.64776659.svg";